export default "__VITE_ASSET__DdTAnPeu__"